import { Button, Col, Container, Image, Row } from 'react-bootstrap';

function Ship() {
  return (
    <><div
      className="justify-content-center hide-on-small"
      style={{ position: "absolute", zIndex: 99 }}
    >
      <div id="circle_v13_wrap" style={{ width: "125px", height: "108px" }}>
        <div id="circle_v13" tabIndex={0}>
          <div
            id="circletype_v13_brand_name"
            className="autoFontSize"
            style={{ fontSize: "calc(16px * 1)" }}
          >
            <a
              target="_blank"
              href="https://www.restaurantji.com/pa/brodheadsville/sauce-/"
              className="ahref_emprty_area ahref_v13_brand_name"
              id="ahref_v13_brand_name" rel="noreferrer"
            >
              Sauce
            </a>
          </div>
          <a
            href="https://www.restaurantji.com/pa/brodheadsville/sauce-/"
            target="_blank" rel="noreferrer"
            id="rewards_link"
            style={{ height: "100%" }}
          >
            Restaurantji
          </a>
        </div>
      </div>
      <script src="https://cdn6.localdatacdn.com/badges/restaurantji/js/circletype.js"></script>
      <script>
        {`new CircleType(document.getElementById("ahref_v13_brand_name")).radius(350)`}
      </script>
    </div>
      <div className="image-wrapper">
                    <Image className="hero-image p-0" width="auto" src="/home.png" alt="logo" />
                    <div className="hero-text cooperl">
                        <Image src="./saucelogo.svg" alt="logo" width="50%" height="50%" />
                        <br />
                        <span>"Come for the food, stay for the friendship"</span>
                        <br />
                        <span style={{fontSize: "1.5rem", fontStyle: "italic"}}>TAKE OUT ~ EAT IN ~ CATERING</span>
                        <br />
                        <Button className="cooperb mt-4 px-4" style={{backgroundColor: "#ff0000", fontSize: "1.5rem", borderRadius: "30px"}} variant="danger" onClick={() => window.location.href = "https://order.online/business/Sauce-12978466?utm_source=sdk&visitorId=19a1b5a918342d45b"}>ORDER NOW</Button>
                    </div>
                </div></>
  );
}
export default Ship;
